module.exports = __webpack_public_path__ + "static/media/general-settings-icon.8ce99b00.svg";